import React, { useState, useEffect } from "react";
import "../../components/Profile/Profile.css";
// import image from "../../images/vishal.jpg";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";

const Profile = ({
  tokenStorage,
  openProfile,
  setOpenProfile,
  selectedEmployeeId,
  successMessage,
  setSuccessMessage,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [employeeDetailResponse, setEmployeeDetailResponse] = useState([]);
  const [departmentResponse, setDepartmentResponse] = useState([]);
  const [designationDetailResponse, setDesignationResponse] = useState([]);
  const [regionDetailResponse, setRegionDetailResponse] = useState([]);
  const [ProfilePicImg, setProfilePicImg] = useState(null);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isNameValid, setIsNameValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isStatusValid, setIsStatusValid] = useState(true);
  const [isError, setIsError] = useState(false);
  const [allocated, setAllocated] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const [firstItem, setFirstItem] = useState({
    customer_id: selectedEmployeeId,
    firstName: "",
    lastName: "",
    status: "",
    gender: "",
    email: "",
    phoneNo: "",
    department: "",
    designation: "",
    region: "",
    createdBy: "Vishal",
    is_active: "true",
    dept_id: "",
    desg_id: "",
    alloted_region: "",

    personal_email: "",
    personal_contact_no: "",
    emp_code: "",

    is_master: false,
    is_sales: false,
    is_account: false,
    is_operation: false,
    is_HR: false,
    ProfilePic: "",
    Date_Of_Joining: "",
    Date_Of_Leaving: "",
    Meal_Preference: "",
    allotedAssetString: "",
    Location: "",
    Alloted_Asset: [],
    product_name:""
  });

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    
    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETEmployee?employeeID=${selectedEmployeeId}&desg_id=0&dept_id=0&region_id=0&meal_Preference=&status=&location=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setEmployeeDetailResponse(response.data.data);
          setProfilePicImg(
            `${baseImageURL}Images/ProfilePics/${response.data.data[0].ProfilePic}`
          );
          if (response.data.data === 0) {
            return <p>No data available.</p>;
          }
          setFirstItem(response.data.data[0]);
        })
        .catch((error) => {
          console.error("Error fetching employee detail:", error);
        });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "ProfilePic") {
      const file = files[0];
      if (file) {
        const allowedTypes = ["image/jpeg", "image/png"];
        if (!allowedTypes.includes(file.type)) {
          alert("Only JPG and PNG files are allowed.");
          return;
        }
        getUpdatedImage(file, name);
      }
    } else {
      setFirstItem((prevItem) => ({
        ...prevItem,
        [name]: value,
      }));

      if (name === "email") {
        validateEmail(value);
      } else if (name === "firstName") {
        setIsNameValid(value.trim() !== "");
      } else if (name === "phoneNo") {
        const isNumeric = /^[0-9]+$/.test(value);
        setIsPhoneValid(isNumeric);

        if (!isNumeric && value !== "") {
          alert("Please enter a valid numeric phone number.");
        }
      } else if (name === "is_active") {
        setIsStatusValid(value !== "0");
      }
    }
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAllAssets?Tseed=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          const options = response.data.data.map((item) => ({
            id: item.Tseed,
            name: item.description,
          }));
          setAllocated(options);
        })
        .catch((error) => {
          console.error("Error fetching assets:", error);
        });
    }
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsEmailValid(emailRegex.test(email));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    console.log(`Uploading file: ${file.name} for field: ${fieldName}`);

    getUpdatedImage(file, fieldName);
  };

  function getUpdatedImage(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setFirstItem((prevItem) => ({
          ...prevItem,
          [name]: imageData,
        }));
        setProfilePicImg(imageData);
      };

      reader.readAsDataURL(file);
    }
  }

  const handleCheckedChange = (event) => {
    const { name, checked } = event.target;
    setFirstItem({
      ...firstItem,
      [name]: checked,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate before submission
    const isFormValid =
      isEmailValid &&
      firstItem.firstName.trim() !== "" &&
      /^[0-9]+$/.test(firstItem.phoneNo) &&
      firstItem.is_active !== "0";

    if (!isFormValid) {
      setIsError(true);
      return;
    }

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminpost/AddEmployee`,
        {
          ...firstItem,
          customer_id: selectedEmployeeId,
          Alloted_Asset: firstItem.Alloted_Asset,
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      setSuccessMessage("Data successfully saved");
      setFirstItem({
        firstName: "",
        lastName: "",
        status: "",
        gender: "",
        email: "",
        phoneNo: "",
        department: "",
        designation: "",
        region: "",
        createdBy: "",
        is_active: "",
        alloted_region: "",
        dept_id: "",
        desg_id: "",
        personal_email: "",
        personal_contact_no: "",
        emp_code: "",
        is_master: false,
        is_sales: false,
        is_account: false,
        is_operation: false,
        is_HR: false,
        ProfilePic: "",
        Location: "",
      });

      tokenStorage();
      setOpenProfile(!openProfile);
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };
  const formatDate = (dateString) => {
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  // console.log("firstItem in profile ", firstItem);
  // console.log("allocatedprofile", allocated);

  // -----------------------------department & Designation-----------------------
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETDepartment?department=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setDepartmentResponse(response.data.data);
          updateDesignation("0");
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const handleSelectChange = (event) => {
    handleChange(event);
    updateDesignation(event.target.value);
  };

  const updateDesignation = (dept) => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETDesignation?designation=0&department=` + dept,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setDesignationResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(`${baseAPI}Adminget/GETRegion?region_id=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          //console.log(response.data.data);
          setRegionDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  // console.log("firstitembvbvbvbv", firstItem);
  return (
    <div className="container-fluid">
      <br />

      <div className="employeeDetail">
        {successMessage && (
          <div style={{ color: "green" }}>{successMessage}</div>
        )}
        {isError && (
          <div style={{ color: "red" }}>
            Please correct the errors before submitting the form.
          </div>
        )}

        <div className="employeeDetailHeader">
          <div className="employeeNameAndImage">
            <div
              style={{
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "white",
              }}
            >
              <div styles={{ height: "10rem" }}>
                {firstItem.ProfilePic && firstItem.ProfilePic.trim() !== "" ? (
                  <img
                    alt="ProfilePic"
                    src={ProfilePicImg}
                    style={{ height: "5rem", width: "5rem" }}
                  />
                ) : (
                  <img alt="Not Found " src="" />
                )}
              </div>
            </div>

            <div className="employeeName">
              <h1 style={{ fontSize: "25px" }}>{firstItem.Name}</h1>
              <span style={{ color: "#878787" }}>{firstItem.department}</span>
            </div>
          </div>

          <div className="ClearTab">
            <button
              onClick={handleSubmit}
              className={isEditMode ? "saveButton" : "closeTabButton"}
            >
              {isEditMode ? "Save" : "Close Tab"}
            </button>
            <button
              className={isEditMode ? "CancelButton" : "editButton"}
              onClick={toggleEditMode}
            >
              {/* Edit {isEditMode ? "" : ""} */}
              {isEditMode ? "Cancel" : "Edit"}
            </button>
          </div>
        </div>

        {/* ---------------------------------------------------------------------------------------------------------------- */}
        {isEditMode ? (
          // --------------Edit mode---------------//
          <form className="employee-form" onSubmit={handleSubmit}>
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>First Name*</td>
                <td>Last Name</td>
                <td>Status</td>
              </tr>

              <tr>
                <td>
                  <input
                    name="firstName"
                    value={firstItem.firstName}
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
                <td>
                  <input
                    name="lastName"
                    value={firstItem.lastName}
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
                <td style={{ color: "#28A745" }}>
                  <select
                    className="dropdown-employee"
                    name="is_active"
                    value={firstItem.is_active}
                    onChange={handleChange}
                  >
                    <option
                      className="dropdown-employee"
                      style={{ color: "grey" }}
                      value="0"
                    >
                      Please select
                    </option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Gender</td>
                <td>Email Name</td>
                <td>Phone No.</td>
              </tr>

              <tr>
                <td>
                  <select
                    className="dropdown-employee"
                    name="gender"
                    value={firstItem.gender}
                    onChange={handleChange}
                  >
                    <option
                      className="dropdown-employee"
                      style={{ color: "grey" }}
                      value=""
                    >
                      Please Select*
                    </option>
                    <option value="1">Male</option>
                    <option value="2">Female</option>
                    <option value="3">Other</option>
                  </select>
                </td>
                <td>
                  <input
                    name="email"
                    value={firstItem.email}
                    onChange={handleChange}
                    className="input-employee"
                  />
                  {!isEmailValid && (
                    <span style={{ color: "red" }}>Invalid email address</span>
                  )}
                </td>
                <td>
                  <input
                    name="phoneNo"
                    value={firstItem.phoneNo}
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Department</td>
                <td>Designation</td>
                <td>Region</td>
              </tr>

              <tr>
                <td>
                  <select
                    className="dropdown-employee"
                    name="dept_id"
                    value={firstItem.dept_id}
                    onChange={handleSelectChange}
                  >
                    <option value="">Select an option</option>
                    {departmentResponse.map((item) => (
                      <option value={item.dept_id}>{item.department}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    className="dropdown-employee"
                    name="desg_id"
                    value={firstItem.desg_id}
                    onChange={handleChange}
                  >
                    <option value="" style={{ width: "5rem" }}>
                      Select an option
                    </option>
                    {designationDetailResponse.map((item) => (
                      <option value={item.desg_id}>{item.designation}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <select
                    name="region"
                    value={firstItem.region}
                    onChange={handleChange}
                    className="dropdown-employee"
                  >
                    <option value="">Select an option</option>
                    {regionDetailResponse.map((item) => (
                      <option value={item.region_id}>{item.region_name}</option>
                    ))}
                  </select>
                </td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr>
                <td>Allocation</td>
                <td>Personal Contact Number</td>
                <td>Personal Email ID</td>
              </tr>
              <tr>
                {" "}
                <td style={{ color: "#28A745" }}>
                  <select
                    className="dropdown-employee"
                    name="alloted_region"
                    value={firstItem.alloted_region}
                    onChange={handleChange}
                  >
                    <option
                      className="dropdown-employee"
                      style={{ color: "grey" }}
                      value=""
                    >
                      Select an option
                    </option>
                    <option value="none">None</option>
                    <option value="international">International</option>
                    <option value="domestic">Domestic</option>
                    <option value="both">Both</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    name="personal_contact_no"
                    value={firstItem.personal_contact_no}
                    placeholder="Please Enter"
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="personal_email"
                    value={firstItem.personal_email}
                    placeholder="Please Enter"
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Employee Code</td>
                <td>Profile Pic</td>
                <td>Meal Preference</td>
              </tr>
              <tr>
                <td>
                  {" "}
                  <input
                    type="text"
                    name="emp_code"
                    value={firstItem.emp_code}
                    placeholder="Please Enter"
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
                <td>
                  <input
                    name="ProfilePic"
                    onChange={handleChange}
                    className="input-employee"
                    type="file"
                  />
                </td>
                <td>
                  <select
                    className="dropdown-employee"
                    name="Meal_Preference"
                    value={firstItem.Meal_Preference}
                    onChange={handleChange}
                  >
                    <option value="">Select an option</option>
                    <option value="Veg">Veg</option>
                    <option value="Non-Veg">Non-Veg</option>
                  </select>
                </td>
              </tr>

              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Date Of Joining</td>
                <td>Date Of Leaving</td>
                <td>Location</td>
              </tr>
              <tr>
                <td>
                  {" "}
                  <input
                    type="Date"
                    name="Date_Of_Joining"
                    value={firstItem.Date_Of_Joining}
                    placeholder="Please Enter"
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
                <td>
                  <input
                    type="Date"
                    name="Date_Of_Leaving"
                    value={firstItem.Date_Of_Leaving}
                    placeholder="Please Enter"
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
                <td>
                  <input
                    type="Location"
                    name="Location"
                    value={firstItem.Location}
                    placeholder="Please Enter"
                    onChange={handleChange}
                    className="input-employee"
                  />
                </td>
              </tr>

              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              {/* <tr className="tableHeading">
                <td>Alloted Assets</td>
                <td></td>
                <td></td>
              </tr> */}
              <tr>
                {/* <td>
                  <Multiselect
                    className="dropdown-employee"
                    style={{
                      multiselectContainer: {
                        border: "2px solid black",
                        borderRadius: "5px",
                        padding: "5px",
                        fontSize: "1rem",
                        backgroundColor: "#fff",
                        color: "#000",
                        height: "3rem",
                      },
                      chips: {
                        background: "#e9ecef",
                        color: "black",
                        borderRadius: "5px",
                      },
                      searchBox: {
                        border: "none",
                        outline: "none",
                      },
                      inputField: {
                        padding: "5px",
                        fontSize: "1rem",
                        height: "2rem",
                      },
                      option: {
                        fontSize: "1rem",
                        padding: "5px",
                        color: "black",
                      },
                    }}
                    options={allocated}
                    selectedValues={
                      typeof firstItem.Alloted_Asset === "string" &&
                      firstItem.Alloted_Asset.trim() !== ""
                        ? firstItem.Alloted_Asset.split(" || ").map(
                            (asset) => ({
                              name: asset.trim(),
                            })
                          )
                        : []
                    }
                    onSelect={(selectedList) => {
                      const selectedAssetNames = selectedList.map(
                        (item) => item.name
                      );
                      setFirstItem({
                        ...firstItem,
                        Alloted_Asset: selectedAssetNames.join(","),
                      });
                    }}
                    onRemove={(selectedList) => {
                      const remainingAssetNames = selectedList.map(
                        (item) => item.name
                      );
                      setFirstItem({
                        ...firstItem,
                        Alloted_Asset: remainingAssetNames.join(","),
                      });
                    }}
                    displayValue="name"
                    placeholder="Select Alloted Assets"
                  />
                </td>
                <td></td>
                <td></td> */}
              </tr>
            </table>
            <br />
            <hr />
            <table className="permission-table">
              <thead>
                <tr>
                  <td colSpan="5" className="permission-header">
                    Please provide permission to access the module
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_sales"
                        checked={firstItem.is_sales}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                      />
                      <span className="label-text">Sales</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_operation"
                        checked={firstItem.is_operation}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                      />
                      <span className="label-text">Operations</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_account"
                        checked={firstItem.is_account}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                      />
                      <span className="label-text">Accounts</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_HR"
                        checked={firstItem.is_HR}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                      />
                      <span className="label-text">HR</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_master"
                        checked={firstItem.is_master}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                      />
                      <span className="label-text">Master</span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <hr />
          </form>
        ) : (
          // --------------Display mode---------------//
          <div>
            <table style={{ width: "100%" }}>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>First Name</td>
                <td>Last Name</td>
                <td>Status</td>
              </tr>

              <tr>
                <td>{firstItem.firstName}</td>
                <td>{firstItem.lastName}</td>
                <td style={{ color: "#28A745" }}>{firstItem.status}</td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Gender</td>
                <td>Email Name</td>
                <td>Phone No.</td>
              </tr>

              <tr>
                <td>{firstItem.gender_name}</td>
                <td>{firstItem.email}</td>
                <td>{firstItem.phoneNo}</td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Department</td>
                <td>Designation</td>
                <td>Region</td>
              </tr>

              <tr>
                <td>{firstItem.department}</td>
                <td>{firstItem.designation}</td>
                <td>{firstItem.region_name}</td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Allocation</td>
                <td>Personal Contact Number</td>
                <td>Personal Email ID</td>
              </tr>
              <tr>
                <td>{firstItem.alloted_region}</td>
                <td>{firstItem.personal_contact_no}</td>
                <td>{firstItem.personal_email}</td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Employee Code</td>
                <td>Date Of Joining </td>
                <td>Date Of Leaving </td>
              </tr>
              <tr>
                <td>{firstItem.emp_code}</td>
                <td>{formatDate(firstItem.Date_Of_Joining)}</td>
                <td>{formatDate(firstItem.Date_Of_Leaving)}</td>
              </tr>

              <tr className="space">
                <td colSpan={3}></td>
              </tr>

              <tr className="tableHeading">
                <td>Meal Preference</td>
                <td>Alloted Assets </td>
                <td> Location </td>
              </tr>
              <tr>
                <td>{firstItem.Meal_Preference}</td>
                <td style={{ width: "30rem", MarginRight: "2rem" }}>
                  {firstItem.product_name}
                </td>
                <td>{firstItem.Location}</td>
              </tr>
            </table>
            <br />
            <hr />
            <table className="permission-table">
              <thead>
                <tr>
                  <td colSpan="5" className="permission-header">
                    Access provided to below module
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_sales"
                        checked={firstItem.is_sales}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                        disabled
                      />
                      <span className="label-text">Sales</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_operation"
                        checked={firstItem.is_operation}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                        disabled
                      />
                      <span className="label-text">Operations</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_account"
                        checked={firstItem.is_account}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                        disabled
                      />
                      <span className="label-text">Accounts</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_HR"
                        checked={firstItem.is_HR}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                        disabled
                      />
                      <span className="label-text">HR</span>
                    </label>
                  </td>
                  <td className="permission-cell">
                    <label className="permission-label">
                      <input
                        type="checkbox"
                        name="is_master"
                        checked={firstItem.is_master}
                        onChange={handleCheckedChange}
                        className="custom-checkbox"
                        disabled
                      />
                      <span className="label-text">Master</span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <hr />
          </div>
        )}
      </div>

      <br />
    </div>
  );
};

export default Profile;
